module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("\n\t\t" + _vm._s(_vm.content) + "\n\t")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', [_c('NbRadio', {
    attrs: {
      "val": "male",
      "name": "gender"
    },
    model: {
      value: (_vm.gender),
      callback: function($$v) {
        _vm.gender = $$v
      },
      expression: "gender"
    }
  }), _vm._v(" "), _c('label', [_vm._v("男")])], 1), _vm._v(" "), _c('div', [_c('NbRadio', {
    attrs: {
      "val": "female",
      "name": "gender"
    },
    model: {
      value: (_vm.gender),
      callback: function($$v) {
        _vm.gender = $$v
      },
      expression: "gender"
    }
  }), _vm._v(" "), _c('label', [_vm._v("女")])], 1), _vm._v(" "), _c('div', [_vm._v("\n\t\t\t\t" + _vm._s(_vm.gender) + "\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 mt20"
  }, [_c('div', [_c('NbCheckbox', {
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }), _vm._v(" "), _c('label', [_vm._v("自动登录")])], 1), _vm._v(" "), _c('div', [_c('NbCheckbox', {
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }), _vm._v(" "), _c('label', [_vm._v("自动登录")])], 1), _vm._v(" "), _c('div', [_vm._v("\n\t\t\t\t" + _vm._s(_vm.checked) + "\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 mt20"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('NbCheckbox', {
    attrs: {
      "val": "Chinese"
    },
    model: {
      value: (_vm.courses),
      callback: function($$v) {
        _vm.courses = $$v
      },
      expression: "courses"
    }
  }), _vm._v(" "), _c('label', [_vm._v("语文")]), _vm._v(" "), _c('NbCheckbox', {
    attrs: {
      "val": "Math"
    },
    model: {
      value: (_vm.courses),
      callback: function($$v) {
        _vm.courses = $$v
      },
      expression: "courses"
    }
  }), _vm._v(" "), _c('label', [_vm._v("数学")]), _vm._v(" "), _c('NbCheckbox', {
    attrs: {
      "val": "English"
    },
    model: {
      value: (_vm.courses),
      callback: function($$v) {
        _vm.courses = $$v
      },
      expression: "courses"
    }
  }), _vm._v(" "), _c('label', [_vm._v("英语")]), _vm._v(" "), _c('NbCheckbox', {
    attrs: {
      "val": "Physics"
    },
    model: {
      value: (_vm.courses),
      callback: function($$v) {
        _vm.courses = $$v
      },
      expression: "courses"
    }
  }), _vm._v(" "), _c('label', [_vm._v("物理")]), _vm._v(" "), _c('NbCheckbox', {
    attrs: {
      "val": "Chemistry"
    },
    model: {
      value: (_vm.courses),
      callback: function($$v) {
        _vm.courses = $$v
      },
      expression: "courses"
    }
  }), _vm._v(" "), _c('label', [_vm._v("化学")]), _vm._v(" "), _c('NbCheckbox', {
    attrs: {
      "val": "Biology"
    },
    model: {
      value: (_vm.courses),
      callback: function($$v) {
        _vm.courses = $$v
      },
      expression: "courses"
    }
  }), _vm._v(" "), _c('label', [_vm._v("生物")])], 1), _vm._v(" "), _c('div', [_vm._v("\n\t\t\t\t" + _vm._s(_vm.courses) + "\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 mt20"
  }, [_vm._m(1), _vm._v(" "), _c('div', _vm._l((10), function(n) {
    return _c('span', [_c('NbCheckbox', {
      attrs: {
        "val": n
      },
      model: {
        value: (_vm.numbers),
        callback: function($$v) {
          _vm.numbers = $$v
        },
        expression: "numbers"
      }
    }), _vm._v(" "), _c('label', [_vm._v(_vm._s(n))])], 1)
  }), 0), _vm._v(" "), _c('div', [_vm._v("\n\t\t\t\t" + _vm._s(_vm.numbers) + "\n\t\t\t")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', [_vm._v("喜欢的科目")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', [_vm._v("喜欢的数字")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-056ef524"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/backyard/view/wheel/NbCheckDemo.vue
// module id = 947
// module chunks = 1